import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { FormTableError } from 'components/_basic/Form/FormTableComponent/components/FormTableError/FormTableError';
import { TextLinkComponent } from 'components/_basic/TextLinkComponent';

import { IEachUnitErrorMessageProps } from './types';

export const EachUnitErrorMessage: React.FC<IEachUnitErrorMessageProps> = ({ scrollToElement }) => {
  const { t } = useTranslation();

  return (
    <FormTableError
      message={
        <Typography variant="subtitle2" component={TextLinkComponent} fontWeight={700} onClick={scrollToElement}>
          {t('financialPlan.plannedExpenses.monthlyExpenses.costPerProduct/Service')}
        </Typography>
      }
    />
  );
};
